import { createQueryKeyStore } from '@lukemorales/query-key-factory';

export const automationQueries = createQueryKeyStore({
  automations: {
    statuses: (districtId: number, statusTypes?: number[]) => ({
      queryKey: [districtId, statusTypes],
    }),
    list: (roleId: number) => ({
      queryKey: [roleId],
    }),
    emailTemplateList: (userId: number) => ({
      queryKey: [userId],
    }),
    referenceEmailTemplateList: (userId: number) => ({
      queryKey: [userId],
    }),
    superAndDistrictAdminList: (districtId: number) => ({
      queryKey: [districtId],
    }),
    referenceTemplateList: (districtId: number) => ({
      queryKey: [districtId],
    }),
  },
});
